// FETCH ALL CHECKING INWARD_DC
export const FETCH_CHECKING_DC_INWARD_MASTER_REQUEST = 'FETCH_CHECKING_DC_INWARD_MASTER_REQUEST';
export const FETCH_CHECKING_DC_INWARD_MASTER_SUCCESS = 'FETCH_CHECKING_DC_INWARD_MASTER_SUCCESS';
export const FETCH_CHECKING_DC_INWARD_MASTER_FAILURE = 'FETCH_CHECKING_DC_INWARD_MASTER_FAILURE';

// CREATE CHECKING INWARD_DC
export const CREATE_CHECKING_DC_INWARD_MASTER_REQUEST = 'CREATE_CHECKING_DC_INWARD_MASTER_REQUEST';
export const CREATE_CHECKING_DC_INWARD_MASTER_SUCCESS = 'CREATE_CHECKING_DC_INWARD_MASTER_SUCCESS';
export const CREATE_CHECKING_DC_INWARD_MASTER_FAILURE = 'CREATE_CHECKING_DC_INWARD_MASTER_FAILURE';

// UPDATE CHECKING INWARD_DC
export const UPDATE_CHECKING_DC_INWARD_MASTER_REQUEST = 'UPDATE_CHECKING_DC_INWARD_MASTER_REQUEST';
export const UPDATE_CHECKING_DC_INWARD_MASTER_SUCCESS = 'UPDATE_CHECKING_DC_INWARD_MASTER_SUCCESS';
export const UPDATE_CHECKING_DC_INWARD_MASTER_FAILURE = 'UPDATE_CHECKING_DC_INWARD_MASTER_FAILURE';

// FETCH SINGLE STATE OF CHECKING INWARD_DC
export const FETCH_SINGLE_CHECKING_DC_INWARD_MASTER_REQUEST = 'FETCH_SINGLE_CHECKING_DC_INWARD_MASTER_REQUEST';
export const FETCH_SINGLE_CHECKING_DC_INWARD_MASTER_SUCCESS = 'FETCH_SINGLE_CHECKING_DC_INWARD_MASTER_SUCCESS';
export const FETCH_SINGLE_CHECKING_DC_INWARD_MASTER_FAILURE = 'FETCH_SINGLE_CHECKING_DC_INWARD_MASTER_FAILURE';

// DELETE CHECKING INWARD_DC
export const DELETE_CHECKING_DC_INWARD_MASTER_REQUEST = 'DELETE_CHECKING_DC_INWARD_MASTER_REQUEST';
export const DELETE_CHECKING_DC_INWARD_MASTER_SUCCESS = 'DELETE_CHECKING_DC_INWARD_MASTER_SUCCESS';
export const DELETE_CHECKING_DC_INWARD_MASTER_FAILURE = 'DELETE_CHECKING_DC_INWARD_MASTER_FAILURE';

export const FETCH_PENDING_CHECKING_PO_IN_INWARD_REQUEST = 'FETCH_PENDING_CHECKING_PO_IN_INWARD_REQUEST';
export const FETCH_PENDING_CHECKING_PO_IN_INWARD_SUCCESS = 'FETCH_PENDING_CHECKING_PO_IN_INWARD_SUCCESS';
export const FETCH_PENDING_CHECKING_PO_IN_INWARD_FAILURE = 'FETCH_PENDING_CHECKING_PO_IN_INWARD_FAILURE';

export const RESET_CHECKING_DC_INWARD_MASTER_INFO = 'RESET_CHECKING_DC_INWARD_MASTER_INFO';

export const CREATE_CHECKING_DC_INWARD_MASTER_FORM = 'CREATE_CHECKING_DC_INWARD_MASTER_FORM';

export const UPDATE_CHECKING_DC_INWARD_MASTER_FORM = 'UPDATE_CHECKING_DC_INWARD_MASTER_FORM';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_CHECKING_DC_INWARD_DETAILS = 'NAVIGATE_CHECKING_DC_INWARD_DETAILS';

// NAVIGATE TO CHECKING INWARD_DC COMPONENT
export const NAVIGATE_CHECKING_DC_INWARD_MASTER = 'NAVIGATE_CHECKING_DC_INWARD_MASTER';
